var map = {
	"./arianna-natale.svg": "90df",
	"./arianna-natale_old.svg": "acb7",
	"./close.svg": "5f8a",
	"./icons/alert.svg": "b1c4",
	"./icons/arrow-back.svg": "7d98",
	"./icons/chevron.svg": "cd20",
	"./icons/close.svg": "251a",
	"./icons/facebook.svg": "a418",
	"./icons/google.svg": "1746",
	"./icons/help.svg": "fba9",
	"./icons/minus.svg": "094a",
	"./icons/plus.svg": "891c",
	"./laconic.svg": "15ed",
	"./laconic_old.svg": "4734",
	"./laconic_talent_management.svg": "9547",
	"./sound-off.svg": "f233",
	"./sound-on.svg": "ac33",
	"./sound.svg": "00c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af31";